// Б.2.d: Техно-палач — Приказ при выставлении (или в момент пробуждения,
// если выставлен в Режиме ожидания).
//
// Эффект: уничтожить ВСЕ Модификации на поле боя (на всех юнитах обоих
// игроков) и получить +1 атаки и +1 Брони за КАЖДУЮ удалённую.
//
// Эпическая → Режим ожидания: если выставлен в ходах 1 или 2, спит до 3-го
// хода. Приказ срабатывает в момент пробуждения, не выставления.
// runUnitOrdersOnReveal расширен в Б.2.d, чтобы обрабатывать как
// свежевыставленных, так и юнитов, чья инициация совпала с currentTurn
// (это и есть «момент пробуждения»).

import { detachMod } from './modifications.js';

export const CARD_ID = 'syn_tehno_palach';

export function tehnoPalachOrder(state, ownerIdx, palach) {
  if (!palach.isAlive()) return;
  const p = state.players[ownerIdx];
  // Снимем все Моды со всех юнитов обоих игроков.
  let total = 0;
  for (const player of state.players) {
    for (let line = 0; line < 2; line++) {
      for (let slot = 0; slot < 4; slot++) {
        const u = player.field[line][slot];
        if (!u || !u.isAlive()) continue;
        // Снимаем по индексу 0 пока есть Моды (detachMod сдвигает массив).
        while (u.modifications && u.modifications.length > 0) {
          const r = detachMod(state, u, 0);
          if (!r.ok) break;
          total++;
        }
      }
    }
  }
  if (total === 0) {
    state.log.add(`🪚 ${palach.name_ru} [${p.name}]: Модов на поле не найдено`);
    return;
  }
  // Бонус: +N атаки, +N Брони (обе постоянные).
  palach.current.atk   += total;
  palach.current.armor += total;
  palach.persistentArmor    = (palach.persistentArmor    || 0) + total;
  palach.persistentMaxArmor = (palach.persistentMaxArmor || 0) + total;
  state.log.add(
    `🪚 ${palach.name_ru} [${p.name}]: уничтожено ${total} Мод(ов) → +${total}/+${total}/0 ` +
    `(итог ${palach.current.atk}/${palach.current.armor}/${palach.current.hp})`
  );
}
